import * as React from 'react'

import { Box, Section } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import Attachment from 'modules/timeoff/components/LeaveTypeSettings/LeaveTypes/UpsertLeaveType/Content/Attachment'
import AttachmentMandatory from 'modules/timeoff/components/LeaveTypeSettings/LeaveTypes/UpsertLeaveType/Content/AttachmentMandatory'
import RequireDetails from 'modules/timeoff/components/LeaveTypeSettings/LeaveTypes/UpsertLeaveType/Content/RequireDetails'
import Restricted from 'modules/timeoff/components/LeaveTypeSettings/LeaveTypes/UpsertLeaveType/Content/Restricted'
import type LeaveTypeFormModel from 'modules/timeoff/lib/LeaveTypeForm'

interface Props {
  leaveTypeForm: LeaveTypeFormModel
  canEditDetails: boolean
  timeoffRestrictedLeaveTypesEnabled: boolean
}

const PermissionsSection = ({
  leaveTypeForm,
  canEditDetails,
  timeoffRestrictedLeaveTypesEnabled,
}: Props) => {
  const handleOnchange = (value: boolean) => {
    leaveTypeForm.setValues({ attachment: value })

    if (value === false) {
      leaveTypeForm.setValues({ is_attachment_mandatory: false })
    }
  }

  const handleRestrictedChange = (value: boolean) => {
    leaveTypeForm.setValues({ restricted: !value })
  }

  const handleIsAttachmentMandatoryChange = (value: boolean) => {
    leaveTypeForm.setValues({ is_attachment_mandatory: value })
  }

  const handleRequireDetailsChange = (value: boolean) => {
    leaveTypeForm.setValues({ details_required: value })
  }

  return (
    <Section
      illustration="visibility"
      title={i18n.t('settings.leave_types.page.permissions.title')}
      description={i18n.t('settings.leave_types.page.permissions.description')}
    >
      <Box gap="s24">
        {timeoffRestrictedLeaveTypesEnabled && (
          <Restricted
            readonly={!canEditDetails}
            field={leaveTypeForm.get('restricted')}
            onChange={handleRestrictedChange}
          />
        )}
        <Attachment
          field={leaveTypeForm.get('attachment')}
          onChange={handleOnchange}
          leaveTypeForm={leaveTypeForm}
        />

        {leaveTypeForm.hasAttachment && (
          <AttachmentMandatory
            field={leaveTypeForm.get('is_attachment_mandatory')}
            onChange={handleIsAttachmentMandatoryChange}
          />
        )}

        <RequireDetails
          field={leaveTypeForm.get('details_required')}
          onChange={handleRequireDetailsChange}
        />
      </Box>
    </Section>
  )
}

export default observer(PermissionsSection)
